import type { Command } from 'commander';
import { registerEnterpriseKeysList } from './list';
import { registerEnterpriseKeysRotate } from './rotate';

export function registerEnterpriseKeysCommand(parent: Command): void {
	const keys = parent.command('keys').description('List and rotate your company API keys');
	registerEnterpriseKeysList(keys);
	registerEnterpriseKeysRotate(keys);
}
